/**
 * @module Theme
 */

import { Component, Input } from '@angular/core';
import { ItemColor } from '@functions/item.functions';
import { ThemeOptionsClass } from '@class/themeOptions.class';
import { ThemeOptionType } from '@models/themeStudio.model';

@Component({
  selector: 'app-theme-option-tooltips-position',
  templateUrl: './theme-option-tooltips-position.component.html',
  styleUrls: ['./theme-option-tooltips-position.component.css']
})
export class ThemeOptionTooltipsPositionComponent {

  @Input() themeOptions: ThemeOptionsClass;

  color = ItemColor('themes');
  optionType: ThemeOptionType = 'tooltips_position';

  constructor() {}

  onValue(value: string) {
    this.themeOptions.setOption('tooltips_position', value);
  }

  values = [
    'average',
    'nearest'
  ];

}
